import axios from "axios";
import Cookies from "js-cookie";
import { RESOURCE_API } from "../apiConstant";
import BaseApi from "../baseApi";

class ResourceApi extends BaseApi {
  constructor() {
    super();
    this.BASE_URL = process.env.REACT_APP_AUTHENTICATION_API_URL || "";
    this.$axiosInstance = this.initAxiosInstance();
  }

  getFile(url, onDownloadProgress, signal) {
    return axios.get(`${url}?token=${Cookies.get("access_token")}`, {
      responseType: "blob",
      onDownloadProgress: onDownloadProgress,
      signal,
    });
  }

  getFreeFile(url, onDownloadProgress, signal) {
    return axios.get(url, {
      responseType: "blob",
      onDownloadProgress: onDownloadProgress,
      signal,
    });
  }

  summaryAll(body) {
    return this.post(`${RESOURCE_API}/summary/all`, body);
  }

  summaryByProgram(body) {
    return this.post(`${RESOURCE_API}/summary/program`, body);
  }

  remove(body) {
    return this.post(`${RESOURCE_API}/remove`, body);
  }

  storeFile(body) {
    return this.post(`${RESOURCE_API}/store`, body);
  }

  deleteFiles(body, abortController) {
    return this.post(`${RESOURCE_API}/delete-files`, body, {
      signal: abortController,
    });
  }

  uploadChunk(body) {
    return this.post(`${RESOURCE_API}/upload-chunk`, body);
  }

  uploadChunkV2(file, resourceRequest, config = {}) {
    const formData = new FormData();

    formData.append("file", file);

    const metadataBlob = new Blob([JSON.stringify(resourceRequest)], {
      type: "application/json",
    });
    formData.append("metadata", metadataBlob);

    return this.post(`${RESOURCE_API}/upload-chunk-v2`, formData, {
      timeout: 100000,
      ...config,
      headers: {
        ...(config.headers || {}),
        "Content-Type": undefined,
      },
    });
  }

  getStreamFileAsBlob(resourceId, onDownloadProgress, signal, headers = {}) {
    return this.get(`${RESOURCE_API}/file/${resourceId}`, null, {
      responseType: "blob",
      onDownloadProgress,
      signal,
      headers,
    });
  }

  getVideoTicket(resourceId, signal) {
    return this.get(`${RESOURCE_API}/video/ticket/${resourceId}`, null, {
      signal,
    });
  }

  downloadFile(resourceId, onDownloadProgress, signal, headers = {}) {
    return this.get(`${RESOURCE_API}/file/download/${resourceId}`, null, {
      responseType: "blob",
      onDownloadProgress,
      signal,
      headers,
      returnFullResponse: true,
    });
  }

  downloadZipFile(resourceId, onDownloadProgress, signal, headers = {}) {
    return this.get(`${RESOURCE_API}/zip/download/${resourceId}`, null, {
      responseType: "blob",
      onDownloadProgress,
      signal,
      headers,
      returnFullResponse: true,
    });
  }

  getResourcesPanel(conversationId) {
    return this.get(`${RESOURCE_API}/panel/${conversationId}`);
  }

  getResourcesArchiveType(body) {
    return this.post(`${RESOURCE_API}/panel/archive`, body);
  }

  getResourcesHistory(body) {
    return this.post(`${RESOURCE_API}/history/viewer`, body);
  }

  getStorage(body) {
    return this.post(`${RESOURCE_API}/storage`, body);
  }

  deleteStorage(body) {
    return this.post(`${RESOURCE_API}/storage/delete`, body);
  }

  getActContentType() {
    return this.get(`${RESOURCE_API}/get-content-type`);
  }

  prepareZip(resourceIds) {
    return this.post(`${RESOURCE_API}/zip/prepare`, { resourceIds });
  }

  deletePhysicalFilesByDateRange(body) {
    return this.post(`${RESOURCE_API}/delete-physical-files`, body);
  }
}
export default ResourceApi;
